import Vue from 'vue';
import mintUI from 'mint-ui';
// import { Loading } from 'vant';
// eslint-disable-next-line no-unused-vars
// import $ from 'jquery';
import App from './App.vue';
import router from './router';
// import store from './store';

import 'mint-ui/lib/style.css';
// import 'vant/lib/index.css';

Vue.use(mintUI);
// Vue.use(Loading);

Vue.config.productionTip = false;
Vue.config.devtools = true;

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app');
